// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"429":"4aa8f1a5","453":"56da0fd9"}[chunkId] + ".chunk.js";
};